import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const AdminReportsDataListItemFile = ({ item }) => {
  const fileTo = {
    pathname: `/files/${item.uuid}`,
    state: {
      modal: true,
      closeUrl: window.location.pathname,
    },
  };

  return (
    <td className="file-image">
      <div>
        <Link to={fileTo} className="list-item-img-wrapper">
          <img
            id={`file-img-${item.uuid}`}
            className="list-item-img"
            width="100%"
            src={item.urls.thumbnail}
            srcSet={`${item.urls.thumbnail} 1x, ${item.urls.thumbnailx2} 2x`}
            alt={item.display_name}
          />
        </Link>
      </div>
    </td>
  );
};

AdminReportsDataListItemFile.propTypes = {
  item: PropTypes.object.isRequired,
};

export default AdminReportsDataListItemFile;
